import get from 'lodash/get'
import Moment from 'moment'
import * as Redux from 'redux'
import * as DateSelector from '../../components/date-selector'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Pager from '../../components/pager'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

type NormalizeTypes = Sortable.TypeNormalizer<Types.Post>
const normalizeTypes: NormalizeTypes = (payload) =>
  payload.posts.map((lp: Types.Post) => ({
    ...lp,
    created_datetime: Moment(lp.created),
    subscription_type_sortable: Utils.subscriptionTypeToNum(lp.subscription_type),
  }))

const emptyViewState: Types.PostsViewState = {
  dateSelect: Constants.DATE_SELECT_LAST_NEWSBRIEF,
  filter: IsActive.FILTER_STATUS_ACTIVE,
  isLoading: false,
  sort: [],
}

type AllActions = Redux.Action &
                  Request.SuccessAction &
                  DateSelector.DatedInformationAction &
                  Sortable.SortAction &
                  IsActive.FilterActionObject &
                  DateSelector.SelectDateRangeAndFilterAction &
                  Actions.PostsServerSortAction

export const postsViewReducer = (state: Types.PostsViewState = emptyViewState, action: AllActions) => {
  switch (action.type) {
    case Constants.POSTS_SERVER_SORT:
      return {
        ...state,
        sort: [{
          dir: action.options.value && action.options.value.length ? action.options.value[0].dir : 'desc',
          field: action.options.value && action.options.value.length ? action.options.value[0].field : 'created',
        }],
      }
    case Request.requestConstant(Constants.FETCH_POSTS):
      return {
        ...state,
        isLoading: true,
      }
    case Request.successConstant(Constants.FETCH_POSTS):
    case Request.errorConstant(Constants.FETCH_POSTS):
      return {
        ...state,
        isLoading: false,
        maxResults: get(action, 'payload.response.max_results', null),
        metadata: get(action, 'payload.response.metadata', null)
        ? get(action, 'payload.response.metadata', null)[0] : null,
      }
    case Request.requestConstant(Constants.FETCH_RECENT_ISSUES):
      return {
        ...state,
        isIssuesLoading: true,
      }
    case Request.successConstant(Constants.FETCH_RECENT_ISSUES):
    case Request.errorConstant(Constants.FETCH_RECENT_ISSUES):
        return {
          ...state,
          isIssuesLoading: false,
          issues: get(action, 'payload.response.issues', null),
        }
    case Constants.SELECT_POSTS_DATE_RANGE:
      return {
        ...state,
        end: action.end,
        start: action.start,
      }
    case Constants.SELECT_POSTS_DATE_RANGE_AND_FILTER:
      return {
        ...state,
        dateSelect: action.dateSelect,
        filter: action.filter,
        sort: action.sort || state.sort,
      }
    case IsActive.filterStatusConstant(Constants.CHANGE_DATE_SELECT):
      return {
        ...state,
        dateSelect: action.filter,
      }
    default:
      return state
  }
}

const reducerEvent: Sortable.ReducerEvent<Types.Post> = {
  defaultSort: {field: 'id', dir: 'desc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_POSTS,
}

const modalReducerEvent: Modal.ReducerEvent<{}> = {
  initializeState: () => ({}),
  requestEvent: Constants.ADD_POST,
  toggleEvent: Actions.FormConstants[Form.ENTER],
}

const postFormReducer = (sourceReducer: any) =>
  (state: Form.State<any>, action: any ) => {
    const sourceState = sourceReducer(state, action);
    if (action.type === Request.successConstant(Constants.ADD_POST)) {
      // add code if needed
      return sourceState
    } else {
      return sourceState
    }
  }

export const reducer = Redux.combineReducers({
  data: IsActive.chainedReducer(Sortable.stateReducer(reducerEvent), Constants.UPDATE_POST),
  form: postFormReducer(Form.createReducer(Constants.POST_FORM)),
  modal: Modal.reducer(modalReducerEvent),
  page: Pager.createReducer(Constants.FETCH_POSTS),
  view: Request.reducerChain([
    postsViewReducer,
    IsActive.filterReducer(Sortable.viewReducer(reducerEvent), Constants.FETCH_POSTS, emptyViewState),
  ]),
})



// WEBPACK FOOTER //
// ./src/pages/posts/reducer.tsx